export default {
  lock: 'https://cdn.hellotech.com/assets/payment-lock.svg',
  fileIcon: 'https://cdn.hellotech.com/assets/file-icon.png',
  spreadsheetIcon: 'https://cdn.hellotech.com/assets/spreadsheet-icon.png',
  imageIcon: 'https://cdn.hellotech.com/assets/image-icon.png',
};
